import React, { useState } from 'react'

// Kalbos ekranas. Lietuvių — aktyvi (app'as lietuviškas). Kitos kalbos —
// vertimas ruošiamas; galima pareikšti norą (išsaugom lokaliai).
const KALBOS = [
  { id: 'lt', pavadinimas: 'Lietuvių', vietinis: 'Lietuvių', paruosta: true },
  { id: 'en', pavadinimas: 'Anglų', vietinis: 'English', paruosta: false },
  { id: 'ru', pavadinimas: 'Rusų', vietinis: 'Русский', paruosta: false },
  { id: 'pl', pavadinimas: 'Lenkų', vietinis: 'Polski', paruosta: false },
]

const NORU_RAKTAS = 'kalbu_norai'

function getNorai() {
  try { return JSON.parse(localStorage.getItem(NORU_RAKTAS)) || [] } catch { return [] }
}

function KalbaEkranas({ atidaryta, onClose, onToast }) {
  const [norai, setNorai] = useState(getNorai())

  function noriu(id) {
    const nauji = norai.includes(id) ? norai : [...norai, id]
    setNorai(nauji)
    try { localStorage.setItem(NORU_RAKTAS, JSON.stringify(nauji)) } catch {}
    if (onToast) onToast('Ačiū! Pranešime, kai kalba bus paruošta')
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: '#141F1A', zIndex: 1001, transform: atidaryta ? 'translateX(0)' : 'translateX(100%)', transition: 'transform 340ms cubic-bezier(0.32,0.72,0,1)', display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: 'calc(14px + env(safe-area-inset-top)) 16px 8px', flexShrink: 0 }}>
        <button onClick={onClose} aria-label="Atgal" style={{ width: 34, height: 34, borderRadius: '50%', border: '1px solid #3A4C42', background: 'transparent', color: '#F0E8D5', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
        </button>
        <span style={{ fontFamily: "'Lora', Georgia, serif", color: '#F0E8D5', fontSize: 19 }}>Kalba</span>
        <div style={{ width: 34 }} />
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: '12px 16px calc(28px + env(safe-area-inset-bottom))' }}>
        <div style={{ background: '#1E2E27', border: '1px solid #2A3B32', borderRadius: 14, overflow: 'hidden' }}>
          {KALBOS.map((k, i) => {
            const noretas = norai.includes(k.id)
            return (
              <div key={k.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 16px', borderBottom: i === KALBOS.length - 1 ? 'none' : '1px solid #2A3B32' }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ color: k.paruosta ? '#F0E8D5' : '#B0B8A8', fontSize: 14 }}>{k.vietinis}</div>
                  <div style={{ color: '#7A8A7E', fontSize: 11.5, marginTop: 2 }}>{k.pavadinimas}{!k.paruosta && ' · vertimas ruošiamas'}</div>
                </div>
                {k.paruosta ? (
                  <span style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#E5A840', fontSize: 12 }}>
                    Pasirinkta
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#E5A840" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5" /></svg>
                  </span>
                ) : noretas ? (
                  <span style={{ color: '#7FB369', fontSize: 12 }}>Pranešime ✓</span>
                ) : (
                  <button onClick={() => noriu(k.id)} style={{ background: 'transparent', border: '1px solid #3A4C42', color: '#F0E8D5', borderRadius: 8, padding: '6px 12px', fontSize: 12, cursor: 'pointer', fontFamily: 'Syne, system-ui, sans-serif' }}>Noriu</button>
                )}
              </div>
            )
          })}
        </div>
        <p style={{ color: '#7A8A7E', fontSize: 12, textAlign: 'center', marginTop: 16, lineHeight: 1.6, padding: '0 12px' }}>
          Kelionių App pradeda nuo Lietuvos ir lietuvių kalbos. Pažymėk „Noriu" — matysim, kurių kalbų labiausiai reikia, ir jas paruošime pirmiausia.
        </p>
      </div>
    </div>
  )
}

export default KalbaEkranas
